import { z } from "zod";

const zOut = z.date().nullable();
type Out = z.infer<typeof zOut>;

export { zOut };
export type { Out };
